import Hero from '@components/home/Hero';
import Services from '@components/home/Services'; // New Services component
import Stats from '@components/home/Stats';
import Industries from '@components/home/Industries';
import Testimonials from '@components/home/Testimonials';
import CTASection from '@components/home/CTASection';

export default function Home() {
  return (
    <>
      <Hero />
      <Services /> {/* New section between Hero and Stats */}
      <Stats />
      <Industries />
      <Testimonials />
      <CTASection />
    </>
  );
}